import React from "react";
import { AvForm } from "availity-reactstrap-validation";
import { CardBody, Card } from "reactstrap";

import type { ModeOfSaleRow } from "@components/Common/PrinterSetting/stores";

import CustomerReceipt from "../CustomerReceipt";
import PrintCustomer from "../PrintCustomer";
import PrintProvider from "../PrintProvider";

type UserCardType = {
    customerTicketSalesModes: ModeOfSaleRow[];
};

function UserCard({ customerTicketSalesModes }: UserCardType) {
    return (
        <Card
            style={{
                fontSize: "17px",
            }}
        >
            <AvForm>
                <CardBody>
                    <CustomerReceipt
                        customerTicketSalesModes={customerTicketSalesModes}
                    />
                    <div className="border-footer__clz p-1" />
                    <PrintCustomer />
                    <div className="border-footer__clz p-1" />
                    <PrintProvider />
                </CardBody>
            </AvForm>
        </Card>
    );
}

export default UserCard;
